import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import MonthEndClosureCont from "presentation/view/container/MonthEndClosure/MonthEndClosureContMain";

CommonEntrypoint(<MonthEndClosureCont />)